import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {isNullOrUndefined} from 'util';

const DEFAULT_ZONE_NAME = 'default';
const DRAG_DATA_TYPE = 'application/tfl-drop-data';

@Directive({
    selector: '[tflDropZone]'
})
export class DropZoneDirective {

    @Output('tflDrop') drop = new EventEmitter();
    private _name: string;

    @Input()
    set tflDropZone(options: DropZoneOptions) {
        if (!isNullOrUndefined(options)) {
            this._name = options.name || DEFAULT_ZONE_NAME;
        }
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event) {
        event.preventDefault();
    }

    @HostListener('drop', ['$event'])
    onDrop(event) {
        event.preventDefault();
        if (this.eventHasDropData(event)) {
            let data = event.dataTransfer.getData(DRAG_DATA_TYPE);//may not work in IE because it does not support custom data types
            this.drop.next(JSON.parse(data).data);
        }
    }

    private eventHasDropData(event): boolean {
        let data = event.dataTransfer.getData(DRAG_DATA_TYPE);
        return (!isNullOrUndefined(data) && data.length > 0) && this.hasValidDestination(data);
    }

    private hasValidDestination(data): boolean {
        let zone = JSON.parse(data).zone;
        return zone === this._name;
    }
}

export interface DropZoneOptions {
    name?: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/drag-and-drop/drop-zone.directive.ts